import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  min-height: calc(100vh - 126px);
  max-height: calc(100vh - 126px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding-top: 10px;
  box-sizing: border-box;
  position: relative;

  &.double {
    left: 15px;
  }

  > div {
    margin: 0;
    align-self: flex-start;

    > div {
      margin: 0;
    }
  }

  &.col-1 {
    > div {
      align-self: flex-end;
    }
  }
`;

export const Thumb = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;

  &:hover {
    img {
      background-color: #223;
      border-radius: 10px;
    }
  }

  &:last-child {
    margin-bottom: 50px;
  }
`;

export const Image = styled.img`
  width: 90%;
`;

export const ImageLoader = styled.div`
  min-height: 150px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
`;

export const New = styled.div`
  margin: 0 auto 5px;
  background-color: transparent;
  border: 1px solid #223;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  cursor: pointer;

  &:hover {
    background-color: #223;
  }
`;

export const Actions = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
`;

export const Placeholder = styled(New)``;
